export type ApiResponse = Record<string, any>;
export interface IDispatchToProps {
  fetchPosts: () => typeof ReportsActionTypes;
}
export interface ReportsState {
  loading?: boolean;
  isReportLoading?: boolean;
  filterLoader?: boolean;
  token?: string;
  resources?: [];
  inputControls?: [];
  error?: [];
}
export interface Items extends ApiResponse {
  token: string;
  data?: any;
}

type ActionTypes = {
  FETCH_REPORTS: string;
  FETCH_REPORTS_SUCCESS: string;
  FETCH_REPORTS_FAILURE: string;
  SET_REPORTS_INITIAL_STATE: string;

  SET_REPORT_TOKEN_TYPES: string;
  SET_REPORT_TOKEN_SUCCESS: string;
  SET_REPORT_TOKEN_FAILURE: string;
  SET_REPORT_TYPES_SUCCESS: string;
  SET_REPORT_TYPES_FAILURE: string;

  FETCH_REPORT_FILTERS_REQUEST: any;
  FETCH_REPORT_FILTERS_SUCCESS: string;
  FETCH_REPORT_FILTERS_FAILURE: string;
};

export const ReportsActionTypes: ActionTypes = {
  FETCH_REPORTS: '@@FETCH_REPORTS',
  FETCH_REPORTS_SUCCESS: '@@FETCH_REPORTS_SUCCESS',
  FETCH_REPORTS_FAILURE: '@@FETCH_REPORTS_FAILURE',

  SET_REPORT_TOKEN_TYPES: '@@SET_REPORT_TOKEN_TYPES',
  SET_REPORT_TOKEN_SUCCESS: '@@SET_REPORT_TOKEN_SUCCESS',
  SET_REPORT_TOKEN_FAILURE: '@@SET_REPORT_TOKEN_FAILURE',
  SET_REPORTS_INITIAL_STATE: '@@SET_REPORTS_INITIAL_STATE',
  SET_REPORT_TYPES_SUCCESS: '@@SET_REPORT_TYPES_SUCCESS',
  SET_REPORT_TYPES_FAILURE: '@@SET_REPORT_TYPES_FAILURE',

  FETCH_REPORT_FILTERS_REQUEST: '@@FETCH_REPORT_FILTERS_REQUEST',
  FETCH_REPORT_FILTERS_SUCCESS: '@@FETCH_REPORT_FILTERS_SUCCESS',
  FETCH_REPORT_FILTERS_FAILURE: '@@FETCH_REPORT_FILTERS_FAILURE'
};
